// eslint-disable-next-line import/prefer-default-export
export var UNIVERSAL_CREDIT_PREFIX = '_uc_';